import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import swal from "sweetalert";
import emailjs from "emailjs-com";

const Contact = () => {
  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "portfolio-mail",
        "template_portnaim",
        e.target,
        "user_p8SiLKgZhrVLKqgqQHyVG"
      )
      .then(
        (result) => {
          if (result.text === "OK") {
            swal("Thank You!", "You message send successfully!", "success");
          }
        },
        (error) => {
          if (error) {
            swal("Sorry", "Something went wrong, try again later", "error");
          }
        }
      );
    e.target.reset();
  };

  return (
    <div className="container" id="contact">
      <h1 className="text-white font-weight-bold mt-5 text-center mb-5">
        Contact With Me
      </h1>
      <div className="d-flex justify-content-center row mb-5">
        <div data-aos="zoom-in" className="col-md-7">
          <form className="needs-validation" onSubmit={sendEmail}>
            <label className="text-white" htmlFor="validationCustom01">
              Your Email
            </label>
            <input
              className="form-control mb-3"
              type="email"
              placeholder="name@example.com"
              name="email"
              id="validationCustom01"
              required
            />
            <label className="text-white" htmlFor="validationCustom02">
              Your Name
            </label>
            <input
              className="form-control mb-3"
              type="text"
              placeholder="Your name / company's name"
              name="name"
              id="validationCustom02"
              required
            />
            <div className="form-group">
              <label className="text-white" htmlFor="validationCustom03">
                Message
              </label>
              <textarea
                className="form-control"
                type="text"
                placeholder="Your message"
                rows="7"
                name="message"
                id="validationCustom03"
                required
              ></textarea>
            </div>
            <input
              className="btn btn-block btn-outline-primary font-weight-bold text-white p-2"
              type="submit"
              value="Send"
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
